import { render } from "./signin-3.vue?vue&type=template&id=c5a5de1e"
import script from "./signin-3.vue?vue&type=script&lang=js"
export * from "./signin-3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__